import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './addnewadmin.scss';

import Navbar from '../Components/Navbar/Navbar';
import Sidebar from '../Components/Sidebar/Sidebar';

import { useNavigate } from 'react-router-dom';

const AddNewAdmin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [admins, setAdmins] = useState([]);


  const [resetPassword, setResetPassword] = useState('');

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const response = await axios.get(
          // 'http://localhost:3005/admin/api/admins'
          'https://portal-sanieldanproperties-api.onrender.com/admin/api/admins'
        );
        setAdmins(response.data);
      } catch (error) {
        if (error.response && error.response.status === 403) {
        } else {
          console.log('Error fetching admins:', error.response ? error.response.data : error.message);
        }
      }
    };

      fetchAdmins();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        // 'http://localhost:3005/admin/addnewadmin'
         'https://portal-sanieldanproperties-api.onrender.com/admin/addnewadmin'
        ,
        { username, password, email }
      );
      console.log(response.data);
      alert('Admin added successfully!');
      setUsername('');
      setPassword('');
      setEmail('');
      setAdmins([...admins, response.data]); // Update the list of admins
    } catch (error) {
      console.log(error);
      alert('Failed to add admin');
    }
  };

  const handleDelete = async (adminId) => {
    try {
      const response = await axios.delete(
        // `http://localhost:3005/admin/delete/${adminId}`
         `https://portal-sanieldanproperties-api.onrender.com/admin/delete/${adminId}`
      );
      console.log(response.data);
      alert('Admin deleted successfully!');
      setAdmins(admins.filter(admin => admin._id !== adminId)); // Update the list of admins
    } catch (error) {
      console.error(error);
      alert('Failed to delete admin');
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    try {
      const authUser = localStorage.getItem("authUser");
      const { username } = JSON.parse(authUser);

      const response = await axios.post(
        // 'http://localhost:3005/admin/resetpassword'
         'https://portal-sanieldanproperties-api.onrender.com/admin/resetpassword'
        ,
        { username, password: resetPassword }
      );
      console.log(response.data);
      alert('Password reset successfully!');
      setResetPassword('');
    } catch (error) {
      console.error(error);
      alert('Failed to reset password');
    }
  };

  return (
    <div className="add_new">
      <div className="home_sidebar">
        <Sidebar />
      </div>

      <div className="new_page">
        <Navbar />

          <>
            <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
              <h1 className="text-2xl font-bold mb-4">Add New Admin</h1>
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-gray-700 text-left">Username</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 text-left">Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 text-left">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
                >
                  Add Admin
                </button>
              </form>
            </div>

            <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
              <h1 className="text-2xl font-bold mb-4">Reset Password</h1>
              <form onSubmit={handlePasswordReset}>
                <div className="mb-4">
                  <label className="block text-gray-700 text-left">New Password</label>
                  <input
                    type="password"
                    value={resetPassword}
                    onChange={(e) => setResetPassword(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
                >
                  Reset Password
                </button>
              </form>
            </div>

            <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
              <h1 className="text-2xl font-bold mb-4">Admin List</h1>
              <table className="min-w-full bg-white">
                <thead>
                  <tr>
                    <th className="py-2">Username</th>
                    <th className="py-2">Email</th>
                    <th className="py-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {admins.map((admin) => (
                    <tr key={admin._id}>
                      <td className="py-2">{admin.username}</td>
                      <td className="py-2">{admin.email}</td>
                      <td className="py-2">
                        <button
                          onClick={() => handleDelete(admin._id)}
                          className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>

      </div>
    </div>
  );
};

export default AddNewAdmin;
